import { useState, useEffect } from "react";
import {
  Box,
  Card,
  Button,
  TextField,
  Autocomplete,
  CardMedia,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import { UseHomeClusters } from "./UseHomeClusters";
import { useRecoilState } from "recoil";
import { rsProgress } from "../../../RecoilStates";
import { FileUploader } from "react-drag-drop-files";
import ClusterAutoComplete from "../../../basic-information/productCluster/ClusterAutoComplete";

export default function HomeClusterFrame(props) {
  const fileTypes = [
    "JPG",
    "jpeg",
    "jfif",
    "pjpeg",
    "pjp",
    "PNG",
    "SVG",
    "webp",
    "GIF",
  ];
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { validate, UpdateProductCluster, AddProductCluster } =
    UseHomeClusters();
  const [clusters, setClusters] = useState();
  const headerColors = ["بدون رنگ", "primary", "secondary"];

  const [state, setState] = useState({
    id: 0,
    aid: props.aid ? props.aid : 0,
    headerColorName: null,
    title: null,
    moreURL: null,
    moreTitle: null,
  });

  const [errorState, setErrorState] = useState({
    title: false,
    clusterID: false,
  });

  const [iconeState, setIconeState] = useState({
    file: undefined,
    url: "",
  });

  useEffect(() => {
    if (props.clusters) {
      setState({
        id: props.clusters.id ? props.clusters.id : 0,
        aid: props.aid,
        headerColorName: props.clusters.headerColorName
          ? props.clusters.headerColorName
          : null,
        title: props.clusters.title ? props.clusters.title : null,
        moreURL: props.clusters.moreURL ? props.clusters.moreURL : null,
        moreTitle: props.clusters.moreTitle ? props.clusters.moreTitle : null,
        clusterID: props.clusters.clusterID ? props.clusters.clusterID : null,
      });
      setIconeState({
        file: undefined,
        url: props.clusters.icon ? props.clusters.icon : null,
      });
    }
  }, [props.clusters]);

  const handleChangeIcone = (file) => {
    setIconeState({
      file: file[0],
      url: URL.createObjectURL(file[0]),
    });
  };

  return (
    <Box
      sx={{ border: "1px solid #E1E1E1", p: 2, borderRadius: 1 }}
      display="grid"
      gridTemplateColumns="repeat(12, 1fr)"
      gap={2}
    >
      <Box gridColumn="span 4">
        <TextField
          fullWidth
          value={state.title ? state.title : ""}
          error={errorState.title}
          label="عنوان"
          size="small"
          variant="outlined"
          onChange={(evt) => {
            setState({ ...state, title: evt.target.value });
          }}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Box>
      <Box gridColumn="span 8"></Box>
      <Box gridColumn="span 4">
        <TextField
          fullWidth
          value={state.moreTitle ? state.moreTitle : ""}
          label="عنوان لینک"
          size="small"
          variant="outlined"
          onChange={(evt) => {
            setState({ ...state, moreTitle: evt.target.value });
          }}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Box>
      <Box gridColumn="span 8"></Box>
      <Box gridColumn="span 6">
        <TextField
          fullWidth
          value={state.moreURL ? state.moreURL : ""}
          label="آدرس لینک"
          size="small"
          sx={{
            textarea: {
              direction: "rtl",
            },
          }}
          multiline
          rows={2}
          variant="outlined"
          onChange={(evt) => {
            setState({ ...state, moreURL: evt.target.value });
          }}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Box>
      <Box gridColumn="span 6"></Box>
      <Box gridColumn="span 3">
        <Autocomplete
          size="small"
          value={state.headerColorName ? state.headerColorName : ""}
          onChange={(event, newValue) => {
            if (newValue == "بدون رنگ") {
              setState({
                ...state,
                headerColorName: null,
              });
            } else if (newValue) {
              setState({
                ...state,
                headerColorName: newValue,
              });
            } else {
              setState({
                ...state,
                headerColorName: null,
              });
            }
          }}
          isOptionEqualToValue={(option, value) => {
            return value == "" || option === value;
          }}
          sx={{ width: "80%" }}
          getOptionLabel={(option) => option}
          fullWidth
          options={headerColors}
          renderInput={(params) => (
            <TextField variant="outlined" {...params} label="رنگ هدر" />
          )}
        />
      </Box>
      <Box gridColumn="span 9"></Box>
      <Box gridColumn="span 3">
        <ClusterAutoComplete
          selectedClusterID={state.clusterID}
          setter={setState}
          lvl1State={state}
          validation={errorState.clusterID}
        />
      </Box>
      <Box gridColumn="span 9"></Box>
      <Box
        gridColumn="span 6"
        sx={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "flex-start",
          gap: 4,
        }}
      >
        <FileUploader
          multiple={true}
          handleChange={(evt) => handleChangeIcone(evt)}
          name="file"
          types={fileTypes}
          children={
            <Box sx={{ width: "100px", height: "auto" }}>
              <Card
                sx={{
                  bgcolor: iconeState.url && "#d7d7d7",
                  p: 1,
                  border: "1px",
                  borderStyle: "dashed",
                  borderColor: "secondary.main",
                  borderRadius: 4,
                  boxShadow: 0,
                  cursor: "pointer",
                }}
              >
                <CardMedia
                  component="img"
                  sx={{ width: "100%", height: "100%" }}
                  image={
                    iconeState.url
                      ? iconeState.url
                      : "/static/img/no-photos.png"
                  }
                />
              </Card>
            </Box>
          }
        />
      </Box>
      <Box gridColumn="span 6"></Box>
      <Box
        gridColumn="span 12"
        sx={{ mt: 2, display: "flex", justifyContent: "center" }}
      >
        <Button
          sx={{ mr: 2, width: "100px" }}
          variant="contained"
          onClick={() => {
            if (validate(state, setErrorState) == 200) {
              setProgress(true);
              if (state.id == 0) {
                AddProductCluster(state, iconeState.file, (calback) => {
                  props.setClusters(calback[0]);
                });
                return;
              } else {
                UpdateProductCluster(state, iconeState.file, (calback) => {
                  props.setClusters(calback[0]);
                });
              }
            }
          }}
        >
          ثبت
        </Button>
      </Box>
    </Box>
  );
}
